import axios from 'axios';

export const getSpeakers = () => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker`,
    method: 'GET',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
}).then(response => response.data.data)

export const getSpeaker = (cacheKeyBase, cacheKeyId) => {
    return axios({
        url: `${process.env.REACT_APP_API_HOST}/speaker/${cacheKeyId}`,
        method: 'GET',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}` || ""
        }
    }).then(response => response.data.data)
}

export const postSpeaker = ({ speaker }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker`,
    method: 'POST',
    data: speaker,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }, 
}).then(response => response.data.data);

export const putSpeaker = ({ _id, speaker }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker/${_id}`,
    method: 'PATCH',
    data: speaker,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);

export const batchPostSpeakers = ({ speakers }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker/batch`,
    method: 'POST',
    data: { speakers },
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }, 
}).then(response => response.data.data);

export const deleteSpeaker = ({ _id }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker/${_id}`,
    method: 'DELETE',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);